import React, { useMemo, type ForwardedRef } from 'react';
import { useProject } from '../../hooks';

// we need to extend the existing react-grid-layout grid component && inject additional controls
// @see: https://github.com/react-grid-layout/react-grid-layout?tab=readme-ov-file#custom-child-components-and-draggable-handles
interface RGContainerProps {
  style?: any;
  className?: string;
  onMouseDown?: any;
  onMouseUp?: any;
  onTouchEnd?: any;
  children?: React.ReactNode;
  [key: string]: any;
  componentId: any;
}
const RGComponent = React.forwardRef<HTMLDivElement, RGContainerProps>(
  (
    { style, className, onMouseDown, onMouseUp, onTouchEnd, children, componentId },
    ref: ForwardedRef<HTMLDivElement>
  ) => {
    const { selectedComponentId } = useProject();

    const isSelected = useMemo(() => {
      return selectedComponentId === componentId;
    }, [selectedComponentId]);

    // TODO: this is brittle
    const childArray = React.Children.toArray(children) as React.ReactElement[];
    const resizeHandler = childArray.filter(
      (child: React.ReactElement) => child.key === '.$resizableHandle-se'
    );
    const otherChildren = childArray.filter(
      (child: React.ReactElement) => child.key !== '.$resizableHandle-se'
    );

    return (
      <div
        style={{ ...style }}
        className={className + (isSelected ? ' selected' : '')}
        ref={ref}
        onMouseDown={onMouseDown}
        onMouseUp={onMouseUp}
        onTouchEnd={onTouchEnd}
      >
        <div className={'grid-item ' + (isSelected ? 'selected' : '')}>{otherChildren}</div>
        {resizeHandler}
      </div>
    );
  }
);

export { RGComponent };
